module.exports = "\n.error_red{\n    color:red\n}\n\n.mdd .multiselect-dropdown .dropdown-btn{border:1px solid #626363!important;}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/css/admin-crud.component.css
// module id = ./src/app/modules/admin/css/admin-crud.component.css
// module chunks = main